import "./TermsConditions.css";
import { VERSION } from "../../constants";
import Breadcrums from "../../components/breadcrums/Breadcrums";
import Breadcrumsv2 from "../../components/breadcrums_v2/Breadcrums";

const BreadcrumsDynamic = VERSION === "1" ? Breadcrums : Breadcrumsv2;

const TermsConditions = () => {
  return (
    <div className="termsconditions">
      <BreadcrumsDynamic />

      <div className="termsconditions-content">
        <div className="tc-subtitle">1. INTRODUCTION</div>
        <div className="tc-descrip">
          <strong>1.1</strong> - Welcome to the Unity platform (the “Site”).
          Please read the following Terms of Service carefully before using this
          Site or opening a Unity account (“Account”) so that you are aware of
          your legal rights and obligations with respect to Unity Momentum Sdn.
          Bhd. (Company Registration No. 202101009013 [1409312-K]) and its
          affiliates and subsidiaries (individually and collectively, “Unity”,
          “we”, “us” or “our”). The “Services” we provide or make available
          include (a) the Site, (b) the services provided by the Site and by
          Unity client software made available through the Site, and (c) all
          information, linked pages, features, data, text, images, photographs,
          graphics, music, sounds, video (including live streams), messages,
          tags, content, programming, software, application services (including,
          without limitation, any mobile application services ) or other
          materials made available through the Site or its related services
          (“Content”). Any new features added to or augmenting the Services are
          also subject to these Terms of Service. These Terms of Service govern
          your use of Services provided by Unity.
        </div>
        <div className="tc-descrip">
          <strong>1.2</strong> - Before becoming a User of the Site, you must
          read and accept all of the terms and conditions in, and linked to,
          these Terms of Service and you must consent to the processing of your
          personal data as described in the Privacy Policy linked hereto.
        </div>
        <div className="tc-descrip">
          <strong>1.3</strong> - Unity reserves the right to change, modify,
          suspend or discontinue all or any part of this Site or the Services at
          any time or upon notice as required by local laws. Unity may release
          certain Services or their features in a beta version, which may not
          work correctly or in the same way the final version may work, and we
          shall not be held liable in such instances. Unity may also impose
          limits on certain features or restrict your access to parts of, or the
          entire, Site or Services in its sole discretion and without notice or
          liability.
        </div>
        <div className="tc-descrip">
          <strong>1.4 </strong> - Unity reserves the right to refuse to provide
          you access to the Site or Services to allow you to open an Account for
          any reason.
          <br />
          BY USING UNITY SERVICES OR OPENING AN ACCOUNT, YOU GIVE YOUR
          IRREVOCABLE ACCEPTANCE OF AND CONSENT TO THE TERMS OF THIS AGREEMENT,
          INCLUDING THOSE ADDITIONAL TERMS AND CONDITIONS AND POLICIES
          REFERENCED HEREIN AND/OR LINKED HERETO.
          <br />
          IF YOU DO NOT AGREE TO THESE TERMS, PLEASE DO NOT USE OUR SERVICES OR
          ACCESS THE SITE. IF YOU ARE UNDER THE LEGAL AGE OF 18, YOU MUST GET
          PERMISSION FROM A PARENT OF LEGAL GUARDIAN TO OPEN AN ACCOUNT AND THAT
          PARENT OR LEGAL GUARDIAN MUST AGREE TO THE TERMS OF THIS AGREEMENT. IF
          YOU DO NOT KNOW WHETHER YOU HAVE REACHED THE LEGAL AGE, OR DO NOT
          UNDERSTAND THIS SECTION, PLEASE DO NOT CREATE AN ACCOUNT UNTIL YOU
          HAVE ASKED YOUR PARENT OR LEGAL GUARDIAN FOR HELP. IF YOU ARE THE
          PARENT OR LEGAL GUARDIAN OF A MINOR WHO IS CREATING AN ACCOUNT, YOU
          MUST ACCEPT THE TERMS OF THIS AGREEMENT ON THE MINOR’S BEHALF AND YOU
          WILL BE RESPONSIBLE FOR ALL USE OF THE ACCOUNT OR COMPANY SERVICES
          USING SUCH ACCOUNT, WHETHER SUCH ACCOUNT IS CURRENTLY OPEN OR CREATED
          LATER.
        </div>

        <div className="tc-subtitle">2. PRIVACY</div>
        <div className="tc-descrip">
          <strong>2.1</strong> - Your privacy is very important to us at Unity.
          To better protect your rights, we have provided the Unity.net.my
          Privacy Policy to explain our privacy practises in detail. Please
          review the Privacy Policy to understand how Unity collects and uses
          the information associated with your Account and/or your use of the
          Services (the “User Information”). By using the Services or providing
          information on the Site, you :
          <br />
          (i) Agree and acknowledge that the proprietary rights of your User
          information are jointly owned by you and Unity; and
          <br />
          (ii) Shall not, whether directly or indirectly, disclose your User
          information to any third party, or otherwise allow any third party to
          access or use your User information, without Unity’s prior written
          consent.
        </div>
        <div className="tc-descrip">
          <strong>2.2</strong> - Users in possession of another User’s personal
          data through the use of the Services (the “Receiving Party”) hereby
          agree that, they will (i) comply with all applicable personal data
          protection laws with respect to any such data; (ii) allow the User
          whose personal data the Receiving Party has collected (the “Disclosing
          Party”) to remove his or her data so collected from the Receiving
          Party’s database; and (iii) allow the Disclosing Party to review what
          information have been collected about them by the Receiving Party, in
          each case of (ii) and (iii) above, in compliance with and where
          required by applicable laws.
        </div>

        <div className="tc-subtitle">3. LIMITED LICENSE</div>
        <div className="tc-descrip">
          Unity grants you a limited and revocable license to access and use the
          Services subject to the terms and conditions of these Terms of
          Service. All proprietary Content, trademarks, service marks, brand
          names, logos and other intellectual property (“Intellectual Property”)
          displayed in the Site are the property of Unity and where applicable,
          third-party proprietors identified in the Site. No right or license is
          granted directly or indirectly to any party accessing the Site to use
          or reproduce any Intellectual Property, and no party accessing the
          Site shall claim any right, title or interest therein. By using or
          accessing the Services, the Site and its Content, you agree not to
          copy, distribute, republish, transmit, publicly display, publicly
          perform, modify, adapt, rent, sell, or create derivative works of any
          portion of the Services, the Site or its Content. You may also not,
          without our prior written consent, on any other server or as party of
          any other website. In addition, you agree that you will not use robot,
          spider or any other automatic device or manual process to monitor or
          copy our Content, without our prior consent ( such consent is deemed
          given for standard search engine technology employed by Internet
          search websites to direct Internet users to this website).
        </div>

        <div className="tc-subtitle">4. ACCOUNTS AND SECURITY</div>
        <div className="tc-descrip">
          <strong>4.1</strong> - Some functions of our Services require
          registration for an Account by selecting a unique user identification
          (“User ID”) and password, and by providing certain personal
          information. If you select a User ID that Unity, in its sole
          discretion, finds offensive or inappropriate, Unity has the right to
          suspend or terminate your Account.
        </div>
        <div className="tc-descrip">
          <strong>4.2</strong> - You agree to (a) keep your password
          confidential and use only your User ID and password when logging in,
          (b) ensure that you log out from your account at the end of each
          session on the Site, (c) immediately notify Unity of any unauthorised
          use of your Account, User ID and/or password, and (d) ensure that your
          Account information is accurate and up-to-date. You are fully
          responsible for all activities that occur under your User ID and
          Account even if such activities or uses were not committed by you.
          Unity will not be liable for any loss or damage arising from
          unauthorised use of your password or your failure to comply with this
          Section.
        </div>
        <div className="tc-descrip">
          <strong>4.3</strong> - You agree that Unity may for any reason, in its
          sole discretion and with or without notice or liability to you or any
          third party, immediately terminate your Account and your User ID,
          remove or discard from the Site any Content associated with your
          Account and User ID, withdraw any subsidies offered to you, cancel any
          transaction or in more serious case permanently withhold any sale
          proceeds or refunds, and/or take any other actions that Unity deems
          necessary. Use of an Account for illegal, fraudulent, harassing,
          defamatory, threatening or abusive purposes may be referred to law
          enforcement authorities without notice to you. If a legal dispute
          arises or law enforcement action is commenced relating to your Account
          or your use of the Services for any reason, Unity may terminate your
          Account immediately with or without notice.
        </div>
        <div className="tc-descrip">
          <strong>4.4</strong> - Users may terminate their Account if they
          notify Unity in writing (including via email at
          customerservice@unity.net.my) of their desire to do so.
          Notwithstanding any such termination, Users remain responsible and
          liable for any incomplete transaction (whether commenced prior to or
          after such termination), shipment of the product payment for the
          product, or the like, and Users must contact Unity after he or she has
          promptly and effectively carried out and completed all incomplete
          transactions according to the Terms of Service. Unity shall have no
          liability, and shall not be liable for any damages incurred due to the
          actions taken in accordance with this Section. Users waive any and all
          claims based on any such action taken by Unity
        </div>

        <div className="tc-subtitle">5. TERM OF USE</div>
        <div className="tc-descrip">
          <strong>5.1</strong> - The license for use of this Site and the
          Services is effective until terminated. This license will terminate as
          set forth under there Terms of Service or if you fail to comply with
          any term or condition of these Terms of Service. In any such event,
          Unity may effect such termination with or without notice to you.
        </div>
        <div className="tc-descrip">
          <strong>5.2</strong> - You agree not to:
          <br />
          (a) Use the Services or upload Content to impersonate any person or
          entity, or otherwise misrepresent your affiliation with a person or
          entity;
          <br />
          (b) Forge headers or otherwise manipulate identifiers in order to
          disguise the origin of any Content transmitted through the Service;
          <br />
          (c) Remove any proprietary notices from the Site;
          <br />
          (d) Cause, permit or authorize the modification, creation of
          derivative works, or translation of the Services without the express
          permission of Unity;
          <br />
          (e) Use the services for the benefit of any third party or any manner
          not permitted by the license granted herein;
          <br />
          (f) Open and/or operate multiple user accounts in connection with any
          conduct that violates either the letter or spirit of these Terms of
          Service;
          <br />
          (g) Access the Unity platform, open a user account, or otherwise
          access your user account using an emulator, simulator, bot or other
          similar hardware or software;
          <br />
          (h) Manipulate the price of any item or interfere with other User’s
          listings;
          <br />
          (i) Attempt to decompile, reverse engineer, disassemble or hack the
          Services (or any portion thereof), or to defeat or overcome any
          encryption technology or security measure implemented by Unity with
          respect to the Services and/or data transmitted, processed or sorted
          by Unity;
          <br />
          (j) Upload, email, post, transmit or otherwise make available any
          Content that you do not have a right to make available under any law
          or under contractual or fiduciary relationships (such as inside
          information, proprietary and confidential information learned or
          disclosed as part of employment relationships or under nondisclosure
          agreements);
          <br />
          (k) Upload, email, post, transmit or otherwise make available any
          Content that infringes any patent, trademark, trade secret, copyright
          or other proprietary rights of any party;
          <br />
          (l) Upload, email, post, transmit or otherwise make available any
          unsolicited or unauthorised advertising, promotional materials, “junk
          mail”, “spam”, “chain letters”, “pyramid schemes”, or any other
          unauthorised form or solicitation;
          <br />
          (m) Upload, email, post, transmit or otherwise make available any
          material that contains software viruses, worms, Trojan horses or any
          other computer code, routines, files or programs designed to directly
          or indirectly interfere with, manipulate, interrupt, destroy or limit
          the functionality or integrity of any computer software or hardware or
          data or telecommunications equipment;
          <br />
          (n) Disrupt the normal flow of dialogue, cause a screen to “scroll”
          faster than other Users of the Services are able to type, or otherwise
          act in a manner that negatively affects other Users’ ability to engage
          in real time exchanges;
          <br />
          (o) Interfere with, manipulate or disrupt the Services or servers or
          networks connected to the Services or any other User’s use and
          enjoyment of the Services, or disobey any requirements, procedures,
          policies or regulations of networks connected to the Site;
          <br />
          (p) Take any action or engage in any conduct that could directly or
          indirectly damage, disable, overburden, or impair the Services or the
          servers or networks connected to the Services;
          <br />
          (q) Use the Services to intentionally or unintentionally violate any
          applicable local, state, national or international law, rule, code,
          directive, guideline, policy or regulation including, without
          limitation, laws and requirements (whether or not having the force of
          law) relating to anti-money laundering or counter-terrorism;
          <br />
          (r) Infringe the rights of Unity, including any intellectual property
          rights and any passing off of the same thereof;
          <br />
          (s) Use the Services to collect or store personal data about other
          Users in connection with the prohibited conduct and activities set
          forth above; and/or
          <br />
          (t) List items which infringe upon the copyright, trademark or other
          intellectual property rights of third parties or use the Services in a
          manner which will infringe the intellectual property rights of others.
        </div>
        <div className="tc-descrip">
          <strong>5.3</strong> - You acknowledge that Unity and its designees
          shall have the right (but not the obligation) in their sole discretion
          to pre-screen, refuse, delete, stop, suspend, remove or move any
          Content (i) that violates these Terms of Service; (ii) If we receive
          complaint from another User, (iii) if we receive a notice or
          allegation of intellectual property infringement or other legal
          instruction objectionable. We may also block delivery of a
          communication (including, without limitation, status updates,
          postings, messages and/or chats) to or from the Services as part of
          our effort to protect the Services or our Users, or otherwise enforce
          the provisions of these Terms and Conditions. In this regard, you
          acknowledge that you have not and, to the maximum extent permitted by
          applicable law, may not rely on any Content created by Unity or
          submitted to Unity, including, without limitation, information in
          Unity Forums and in all other parts of the Site.
        </div>
        <div className="tc-descrip">
          <strong>5.4</strong> - You acknowledge, consent to and agree that
          Unity may access, preserve and disclose your Account information to
          any legal, regulatory, or governmental authority, the relevant rights
          owner, or other third parties if required to do so by law pursuant to
          an order of a court or lawful request by any governmental or
          regulatory authority having jurisdiction over Unity or in a good faith
          belief that such access preservation or disclosure is reasonably
          necessary to: (a) comply with the legal process; (b) enforce these
          Terms of Service; (c) respond to claims that any Content violates the
          rights of third parties, including intellectual property rights; (d)
          protect the rights, property or personal safety of Unity, its Users
          and/or the public.
        </div>

        <div className="tc-subtitle">6. VIOLATION OF OUR TERMS OF SERVICES</div>
        <div className="tc-descrip">
          <strong>6.1</strong> - Violations of this policy may result in a range
          of actions, including, without limitation, any or all of the
          following:
          <br />
          - Limits placed on Account privileges
          <br />
          - Account suspension and subsequent termination
          <br />
          - Criminal charges
          <br />- Civil actions, including without limitation a claim for
          damages and/or interim or injunctive relief
        </div>
        <div className="tc-descrip">
          <strong>6.2</strong> - If you believe a User on our Site is violating
          these Terms of Service, please contact : customerservice@unity.net.my
        </div>

        <div className="tc-subtitle">7. PURCHASE AND PAYMENT</div>
        <div className="tc-descrip">
          <strong>7.1</strong> - The Buyer shall be entitled to make payment for
          the Goods using the various payment methods make available on the
          Platform. When Buyer places an order on the Platform, actual payment
          shall be only charged upon Seller’s acceptance of Buyer’s order and
          the information of a Contract.
        </div>
        <div className="tc-descrip">
          <strong>7.2</strong> - Unity supports one or more of the following
          payment methods in each country it operates in:
          <br />
          (i) FPX
          <br />
          FPX payment allow Buyer to complete transactions online using their
          bank credentials. There is a maximum transaction limit for this
          payment method. If you’ve met the transaction limit, then you can try
          using the alternative payment methods or separate your order into two
          (2) separate order.
          <br />
          (ii) Bank Transfer (IBG)
          <br />
          By choosing this payment method, the Buyer shall transfer the amount
          of total purchase price for the Goods purchased by Buyer to a Unity
          account (including any applicable taxes, fees and shipping costs). The
          transaction must be payable in Ringgit Malaysia. Unity, in its sole
          discretion, may refuse this payment option service to anyone or any
          user without notice for any reason at any time. Buyer may make
          payments through an Automated Teller Machine or internet bank transfer
          (“Bank Transfer”) to our designated Unity Guaranteed Account (as
          defined in Section 12). Buyer must provide Unity with the transfer
          receipt or payment transaction reference for verification purposes
          through the “Upload Slip” function found in Unity’s website as payment
          confirmation. If payment confirmation is not received by Unity within
          24 hours, Buyer’s order will be cancelled.
          <br />
          (iii)Cheque
          <br />
          Buyer may pay via a Cheque Deposit Machine (CQM) and upload the bank
          receipt for verification purposes via the “Upload Slip” function on
          Unity’s website as payment confirmation. Payment should be done within
          24 hours to avoid auto-cancellation of Buyer’s order.
        </div>

        <div className="tc-subtitle">8. DELIVERY</div>
        <div className="tc-descrip">
          <strong>8.1</strong> - Delivery of the Goods shall be made to the
          address specified by the Buyer in its order.
        </div>
        <div className="tc-descrip">
          <strong>8.2</strong> - Unity has the right at any time to sub-contract
          all or any of its obligations for the sale/delivery of the Goods to
          any other party as it may from time to time decide without giving
          notice of the same to Buyer.
        </div>
        <div className="tc-descrip">
          <strong>8.3</strong> - Unity has no responsibilities on the delivery
          time if the Goods is delivered by thirdparty. Seller should understand
          and agrees that Unity is unable to set/confirm the delivery time.
        </div>

        <div className="tc-subtitle">
          9. CANCELLATION, RETURN, REFUND AND REPLACEMENT OF GOODS
        </div>
        <div className="tc-descrip">
          <strong>9.1</strong> - All Goods sold on the Platform is covered under
          the Unity 7 Days Easy Return. Buyer may initiate the returns process
          by communicating with Unity Customer Service through the Platform.
        </div>
        <div className="tc-descrip">
          <strong>9.2</strong> - Buyer may, by completing the Online Return
          Form, apply to return the purchased Goods to Unity in exchange of a
          replacement or a refund. Buyer shall ensure that the purchased Goods
          is returned to Unity within 7 calendar days from the delivery date,
          depending on the applicable Return Policy. For avoidance of doubt, the
          countdown starts from the date the Buyer received the purchase Goods
          to the post stamp date on the return parcel.
        </div>
        <div className="tc-descrip">
          <strong>9.3</strong> - Buyer must submit the Online Return Form to
          Unity Customer Service before returning the purchased Goods. Please
          refer to the Return and Refund Policy on the return process.
        </div>
        <div className="tc-descrip">
          <strong>9.4</strong> - In cases if Buyer noticed that the parcel has
          visible damaged , defective or incorrect item, Buyer should not sign
          on the “Proof of Delivery Form” and should reject the parcel on the
          spot. Unity will not be responsible if the parcel has been signed
          receipt by Buyer.
        </div>
        <div className="tc-descrip">
          <strong>9.5</strong> - Buyer may only cancel his/her order prior to
          the payment of Buyer’s Monies into Unity Bank Account.
        </div>
        <div className="tc-descrip">
          <strong>9.6</strong> - Buyer may apply for the return of the purchased
          Goods in the following circumstances:
          <br />
          (i) The Goods delivered to Buyer is defective and/or damaged on
          delivery;
          <br />
          (ii) The Goods delivered to Buyer is materially different from the
          description provided by Seller in the listing of the Goods;
          <br />
          (iii)The Goods delivered to Buyer does not match the agreed
          specification (e.g. wrong size, colour, etc.) stipulated in the order;
          <br />
          (iv)Such other circumstances which may be prescribed by Unity on
          Platform.
        </div>
        <div className="tc-descrip">
          <strong>9.7</strong> - The application for return of Purchased Goods
          may also be subject to additional terms and conditions prescribed by
          Unity on the Platform. Please see Customer Service for further
          details.
        </div>
        <div className="tc-descrip">
          <strong>9.8</strong> - Unity reserves the right to cancel any
          transaction on the Site. Buyer should refer to Unity’s Refund and
          Return Policy on the Return and Refund process.
        </div>
        <div className="tc-descrip">
          <strong>9.9</strong> - Refunds to Buyers shall be made to their bank
          account within 72 hours of the return of refund request being
          approved.
        </div>

        <div className="tc-subtitle">
          10. EXCLUSIONS AND LIMITATIONS OF LIABILITY
        </div>
        <div className="tc-descrip">
          <strong>10.1</strong> - TO THE MAXIMUM EXTEND PERMITTED BY APPLICABLE
          LAW, IN NO EVENT SHALL UNITY BE LIABLE WHETHER IN CONTRACT, WARRANTY,
          TORT (INCLUDING, WITHOUT LIMITATION, NEGLIGENCE (WHETHER ACTIVE,
          PASSIVE OR IMPUTED), PRODUCT LIABILITY, STRICT LIABILITY OR OTHER
          THEORY), OR OTHER CAUSE OF ACTION AT LAW, IN EQUITY, BY STATUTE OR
          OTHERWISE, FOR :
          <br />
          (i) (A) LOSS OF USE; (B) LOSS OF PROFITS; (C) LOSS OF REVENUES; (D)
          LOSS OF DATA; (E) LOSS OF GOOD WILL; OR (F) FAILURE TO REALISE
          ANTICIPATED SAVINGS, IN EACH CASE WHETHER DIRECT OR INDIRECT; OR
          <br />
          (ii) ANY INDIRECT, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES,
          ARISING OUT OF OR IN CONNECTION WITH THE USE OR INABILITY TO USE THIS
          SITE OR THE SERVICES, INCLUDING, WITHOUT LIMITATION, ANY DAMAGES
          RESULTING THEREFROM, EVEN IF UNITY HAS BEEN ADVISED OF THE POSSIBILITY
          OF SUCH DAMAGES.
        </div>
        <div className="tc-descrip">
          <strong>10.2</strong> - IF, NOTWITHSTANDING THE PREVIOUS SECTIONS,
          UNITY IS FOUND BY A COURT OF COMPETENT JURISDICITON TO BE LIABLE
          (INCLUDING FOR GROSS NEGLIGENCE), THEN, TO THE MAXIMUM EXTEND
          PERMITTED BY APPLIBALE LAW, ITS LIABILITY TO YOU OR ANY THIRD PARTY IS
          LIMITED TO THE LESSER OF: (A) ANY AMOUNTS DUE AND PAYABLE TO YOU
          PURSUANT TO THE UNITY GUARANTEE; AND (B) RM500 ( FIVE HUNDRED MALAYSIA
          RINGGIT).
        </div>
        <div className="tc-descrip">
          <strong>10.3</strong> - NOTHING IN THESE TERMS OF SERVICE SHALL LIMIT
          OR EXCLUDE ANY LIABILITY FOR DEATH OR PERSONAL INJURY CAUSED BY
          UNITY’S NEGLIGENCE, FOR FRAUD OR FOR ANY OTHER LIABILITY ON THE PART
          OF UNITY THAT CANNOT BE LAWFULLY LIMITED AND/OR EXCLUDED.
        </div>

        <div className="tc-subtitle">
          11. YOUR REPRESENTATIONS AND WARRANTIES
        </div>
        <div className="tc-descrip">
          You represent and warrant that:
          <br />
          (a) You possess the legal capacity (and in the case of a minor, valid
          parent or legal guardian consent), right and ability to enter into
          these Terms of Service and to comply with its terms; and
          <br />
          (b)You will use the Services for lawful purposes only and in
          accordance with these Terms of Service and all applicable laws, rules,
          code, directives, guidelines, policies and regulations.
        </div>

        <div className="tc-subtitle">12. FRAUDULENT OR SUSPICIOUS ACTIVITY</div>
        <div className="tc-descrip">
          If Unity, in its sole discretion, believes that you may have engaged
          in any potentially fraudulent or suspicious activity and/or
          transactions, we may take various actions to protect Unity, other
          Buyers, other third-party or you from Reversals, Chargebacks, Claims,
          fees, fines, penalties and any other liability. The actions we may
          take include but are not limited to the following:
          <br />
          (a) We may close, suspend, or limit your access to your Account or the
          Services, and/or suspend the processing of any transaction;
          <br />
          (b) We may hold, apply or transfer the funds in your Account as
          required by judgements and order which affect you or your Account,
          including judgements and orders issued by courts in Malaysia or
          elsewhere and directed to Unity;
          <br />
          (c) We may refuse to provide the Services to you now and in the
          future;
          <br />
          (d) We may hold your funds for a period of time reasonably needed to
          protect against the risk of liability to the Unity or a third party,
          or if we believe that you may engaging in potentially fraudulent or
          suspicious activity and/or transactions.
        </div>
        <div className="tc-descrip">
          For the purposes of this Section :
          <br />
          “Chargeback” means a request that a Buyer files directly with his or
          her debit or credit card company or debit or credit card issuing bank
          to invalidate a payment.
          <br />
          “Claim” means a challenge to a payment that a Buyer or Seller files
          directly with Unity.
        </div>

        <div className="tc-subtitle">13. INDEMNITY</div>
        <div className="tc-descrip">
          You agree to indemnify, defend and hold harmless Unity, and its
          shareholders, subsidiaries, affiliates, directors, officers, agents,
          co-branders or other partners, and employees (collectively, the
          “Indemnified Parties”) from and against any and all claims, actions,
          proceedings, and suits and all related liabilities, damages,
          settlements, penalties, fines, costs and expenses (including, without
          limitation, any other dispute resolution expenses) incurred by any
          indemnified Party arising out of relating to: (a) any transaction made
          on the Site, or any dispute in relation to such transaction (except
          where Unity or its Affiliates is the Seller in the transaction that
          the dispute relates to), (b) the hosting, operation, management and/or
          administration of the Services by or on behalf of Unity, (c) your
          violation or breach of any term of these Terms of Service or any
          policy or guidelines referenced herein, (d) your use or misuse of the
          Services, (e) your breach of any law or any rights of a third-party.
        </div>

        <div className="tc-subtitle">14. SEVERABILITY</div>
        <div className="tc-descrip">
          If any, provision of these Terms of Service shall be deemed unlawful,
          void, or for any reason unenforceable under the law of any
          jurisdiction, then that provision shall be deemed severable from these
          terms and conditions and shall not affect the validity and
          enforceability of the provision in question under the law of any other
          jurisdiction.
        </div>

        <div className="tc-subtitle">15. GOVERNING LAW</div>
        <div className="tc-descrip">
          These Terms of Service shall be governed by and constructed in
          accordance with the laws of Malaysia without regard to its conflict of
          law rules. The United Nations Convention on Contracts for the
          International Sale of Goods and the Uniform Computer Information
          Transaction Act, to the extent applicable, are expressly disclaimed.
          Unless otherwise required by applicable laws, any dispute,
          controversy, claim or difference of any kind whatsoever shall arising
          out of or relating to these Terms of Service against or relating to
          Unity or any Indemnity Party under these Terms of Service shall be
          referred to and finally resolved by arbitration in Malaysia in
          accordance with the Arbitration Rules of the Malaysia International
          Arbitration Centre (“MIAC Rules”) for the time being in force, which
          rules are deemed to be incorporated by reference in this Section.
          There will be one (1) arbitrator and the language of the arbitration
          shall be English.
        </div>

        <div className="tc-subtitle">16. GENERAL PROVISIONS</div>
        <div className="tc-descrip">
          <strong>16.1</strong> - Unity reserves all rights not expressly
          granted herein.
        </div>
        <div className="tc-descrip">
          <strong>16.2</strong> - Unity may modify these Terms of Service at any
          time by posting the revised Terms of Service on this Site. Your
          continued use of this Site after such changes have been posted shall
          constitute your acceptance of such revised Terms of Service.
        </div>
        <div className="tc-descrip">
          <strong>16.3</strong> - You may not assign, sublicense or transfer any
          rights granted to you hereunder or subcontract any of your
          obligations.
        </div>
        <div className="tc-descrip">
          <strong>16.4</strong> - Nothing in these Terms of Service shall
          constitute a partnership, joint venture or principal-agent
          relationship between you and Unity, nor does it authorise you to incur
          any costs or liabilities on Unity’s behalf
        </div>
        <div className="tc-descrip">
          <strong>16.5</strong> - The failure of Unity at any time or times to
          require performance of any provision hereof shall in no manner affect
          its right at a later time to enforce the same unless the same is
          waived in writing.
        </div>
        <div className="tc-descrip">
          <strong>16.6</strong> - These Terms of Service are solely for your and
          our benefit and are not for the benefit of any other person or entity,
          except for Unity’s affiliates and subsidiaries (and each of Unity’s
          and its affiliates’ and subsidiaries’ respective successors and
          assigns).
        </div>
        <div className="tc-descrip">
          <strong>16.7</strong> - The terms set forth in these Terms of Service
          and any agreements and policies included or referred to in these Terms
          of Services constitute the entire agreement and understanding of the
          parties with respect to the Services and the Site and supersede any
          previous agreement or understanding between the parties in relation to
          such subject matter. The parties also hereby exclude all implied terms
          in fact. In entering into the agreement formed by these Terms of
          Service, the parties have not relied on any statement, representation,
          warranty, understanding, undertaking, promise or assurance of any
          person other than as expressly set out in these Terms of Service. Each
          party irrevocably and unconditionally waives all claims, rights and
          remedies which but for this Section it might otherwise have had in
          relation to any of the foregoing. These Terms of Service may not be
          contradicted, explained or supplemented by evidence of any prior
          agreement, any contemporaneous oral agreement or any consistent
          additional terms.
        </div>
        <div className="tc-descrip">
          <strong>16.8</strong> - You agree to comply with all applicable laws,
          statutes, regulations and codes relating to anti-bribery and
          corruption including without limitation the UK Bribery Act, the US
          Foreign Corrupt Practices Act and the Malaysia Prevention of
          Corruption Act and confirm that you have and shall have in place all
          policies and procedures needed to ensure compliance with such
          requirements.
        </div>
        <div className="tc-descrip">
          <strong>16.9</strong> - If you have any questions or concerns about
          these Terms of Services or any issues raised in these Terms of Service
          or on the Site, please contact us at: customerservice@unity.net.my
        </div>
        <div className="tc-descrip">
          LEGAL NOTICES : Please send all legal notices to legal.my@untiy.net.my
          and Attention it to the “General Counsel”.
        </div>
        <div className="tc-descrip">
          I HAVE READ THIS AGREEMENT AND AGREE TO ALL OF THE PROVISIONS
          CONTAINED ABOVE ANY REVISION THE SAME HEREAFTER. BY CLICKING THE “SIGN
          UP” OR “CONNECT WITH FACEBOOK” BUTTON DURING REGISTRATION, I
          UNDERSTAND THAT I AM CREATING A DIGITAL SIGNATURE, WHICH I INTEND TO
          HAVE THE SAME FORCE AND EFFECT AS IF I HAD SIGNED MY NAME MANUALLY.
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
